export default __webpack_public_path__ + "static/media/AB.54ffa7dd.svg";